<div
	mat-dialog-title
	class="!flex items-center gap-2">
	{{ "protocols.notes.list.title" | translate }}
	@if (!isLoading && notes.length > 0) {
		<span class="notes-count">{{ "protocols.notes.list.count" | translate: { count: notes.length } }}</span>
	}
	<app-help-button
		class="ml-auto"
		context="protocols.notes" />
</div>

<div mat-dialog-content>
	@if (isLoading) {
		<div class="notes-loading">
			<mat-spinner diameter="40" />
		</div>
	} @else if (notes.length === 0) {
		<p class="notes-empty">{{ "protocols.notes.list.empty" | translate }}</p>
	} @else {
		<div class="flex flex-col notes-list">
			@for (note of notes; track note.id) {
				<div
					class="note-card"
					[class.note-card-focused]="note.id === data.focusNoteId">
					<div class="note-header">
						<div class="note-meta">
							@if (note.version) {
								<span class="note-chip">v{{ note.version }}</span>
							}
							@if (!isMine(note)) {
								<span class="note-chip note-chip-author">{{ note.user | name }}</span>
							}
							<span class="note-date">{{ note.created_at | date: "short" }}</span>
						</div>
						<div class="note-actions">
							@if (canLocate(note)) {
								<button
									mat-icon-button
									[matTooltip]="'protocols.notes.actions.locate' | translate"
									(click)="locate(note)">
									<mat-icon>my_location</mat-icon>
								</button>
							}
							@if (isMine(note)) {
								<button
									mat-icon-button
									[matTooltip]="'core.edit' | translate"
									(click)="edit(note)">
									<mat-icon>edit</mat-icon>
								</button>
								<button
									mat-icon-button
									[matTooltip]="'core.delete' | translate"
									(click)="remove(note)">
									<mat-icon>delete</mat-icon>
								</button>
							}
						</div>
					</div>

					@if (note.outdated) {
						<div class="note-outdated">
							<mat-icon>history</mat-icon>
							<span>{{ "protocols.notes.outdated" | translate: { version: note.version } }}</span>
						</div>
					}

					@if (note.selected_text) {
						<blockquote class="note-quote">{{ note.selected_text }}</blockquote>
					}

					<p class="note-content">{{ note.content }}</p>
				</div>
			}
		</div>
	}
</div>

<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		(click)="close()">
		{{ "core.close" | translate }}
	</button>
</div>
